import * as api from "./api";

export const GET_ALL_WORKSPACE_MEMBERS = "magnifi/workspace/GET_ALL_WORKSPACE_MEMBERS";
export const UPDATE_WORKSPACE_MEMBER = "magnifi/workspace/UPDATE_WORKSPACE_MEMBER";
export const REMOVE_WORKSPACE_MEMBER = "magnifi/workspace/REMOVE_WORKSPACE_MEMBER";

export const getAllWorkspaceMembers = () => {
  return {
    type: GET_ALL_WORKSPACE_MEMBERS,
    payload: api.getAllWorkspaceMembers(),
  };
};

export const updateWorkspaceMember = (data) => {
  return {
    type: UPDATE_WORKSPACE_MEMBER,
    payload: api.updateWorkspaceMember(data),
  };
};

export const removeWorkspaceMember = (data) => {
  return {
    type: REMOVE_WORKSPACE_MEMBER,
    payload: api.removeWorkspaceMember(data),
  };
};
